/**
 * EOFY "Buy 2, get one free" display layer.
 *
 * Single source of truth for the offer message and the eligible tea count.
 * Both the cart drawer progress banner and the site wide sticky bar read from
 * this one module, so they can never show a different number.
 *
 * Eligibility signal: membership of the `all-teas` collection, stamped onto
 * each cart line item by Liquid as data-tea-bogo-eligible / data-tea-bogo-qty.
 * That is the same collection the automatic discount uses.
 *
 * Customer facing copy contains NO dashes of any kind (brand rule).
 */
(function () {
  if (window.__teaBogoInit) return;
  window.__teaBogoInit = true;

  var WORDS = [
    'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
    'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
  ];

  function word(n) {
    return WORDS[n] || String(n);
  }

  /**
   * The Buy 2 Get 1 ladder, generalised for any quantity.
   * free = number of teas already free (one per completed group of 3).
   * rem  = teas into the current group of 3 (0, 1 or 2).
   */
  function message(n) {
    if (!n || n < 1) {
      return 'Buy any 2 teas and the third is on us. Mix any blends you like';
    }

    var free = Math.floor(n / 3);
    var rem = n % 3;

    if (rem === 0) {
      return free === 1 ? 'One tea is on us' : word(free) + ' teas on us';
    }

    var remaining = 3 - rem; // 1 or 2 teas to the next free one
    var teaWord = remaining === 1 ? 'tea' : 'teas';
    var tail = free === 0 ? 'and get one free' : 'for another one free';
    return 'Add ' + remaining + ' more ' + teaWord + ' ' + tail;
  }

  /**
   * Authoritative eligible count. The cart drawer lives in the header on every
   * page and re-renders (DOM morph) on cart:update, so its line items are the
   * one fresh source we read everywhere. Reading a single source is what keeps
   * the banner and the sticky bar identical.
   */
  function countEligible() {
    var scope = document.querySelector('cart-drawer-component');

    if (scope) {
      var total = 0;
      scope.querySelectorAll('[data-tea-bogo-eligible="true"]').forEach(function (row) {
        total += parseInt(row.getAttribute('data-tea-bogo-qty'), 10) || 0;
      });
      return total;
    }

    // Fallback before the drawer exists in the DOM: trust the server count.
    var banner = document.querySelector('[data-tea-bogo-banner]');
    return banner ? parseInt(banner.getAttribute('data-tea-bogo-count'), 10) || 0 : 0;
  }

  function render() {
    var n = countEligible();
    var msg = message(n);
    var rem = n % 3;
    var justEarned = n > 0 && rem === 0;
    var progress = justEarned ? 1 : rem / 3;

    document.querySelectorAll('[data-tea-bogo-text]').forEach(function (el) {
      el.textContent = msg;
    });
    document.querySelectorAll('[data-tea-bogo-fill]').forEach(function (el) {
      el.style.width = progress * 100 + '%';
    });
    document.querySelectorAll('[data-tea-bogo-banner]').forEach(function (el) {
      el.setAttribute('data-tea-bogo-state', justEarned ? 'earned' : n > 0 ? 'progress' : 'empty');
    });

    // Sticky bar only nudges when there is progress to show: hide it at 0.
    document.querySelectorAll('[data-tea-bogo-sticky]').forEach(function (el) {
      if (n > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  var frame;
  function scheduleRender() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(render);
  }

  // Recompute whenever the cart changes.
  document.addEventListener('cart:update', scheduleRender);

  // The drawer updates by DOM morph; observing it makes the count correct
  // regardless of cart:update listener ordering.
  function observe() {
    var scope = document.querySelector('cart-drawer-component');
    if (!scope) return;
    new MutationObserver(scheduleRender).observe(scope, { childList: true, subtree: true });
  }

  function start() {
    render();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
